import React from 'react';
import { Avatar, Box, Tooltip } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { Loader } from '../../shared/layout/Loader';
import { useAuth } from '../context/AuthenticationProvider';

export function UserProfileMenu(): React.ReactElement {
  const state = useAuth();
  const { user, isLoading } = state;

  return isLoading ? (
    <Loader />
  ) : !user ? (
    <></>
  ) : (
    <Box
      sx={{
        display: 'flex',
        borderLeft: `1px solid ${colorPalette.grey.main}`,
      }}
    >
      <Tooltip title={<>{user.name}</>}>
        <Avatar src={user.picture} />
      </Tooltip>
    </Box>
  );
}
